import { render, staticRenderFns } from "./Halo.vue?vue&type=template&id=9701359c&scoped=true"
import script from "./Halo.vue?vue&type=script&lang=ts"
export * from "./Halo.vue?vue&type=script&lang=ts"
import style0 from "./Halo.vue?vue&type=style&index=0&id=9701359c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9701359c",
  null
  
)

export default component.exports